export const LAST_LOCAL_PACK_ACTIVATION_FORM_STEP_INDEX = 1;
